<template>
    <div>
        <div v-for="task in tasks" :key="task.id">
            <span class="task">
                <activation-task-icon v-if="task.network_id || isCustomTask(task)" :task="task" />

                <info-popup v-else placement="left" style="margin: 0 4px">
                    <p>This task does not depend on a network.</p>
                </info-popup>

                <g-typography v-if="task.name" :value="task.name + quantityString(task)" />
            </span>
        </div>
    </div>
</template>

<script>
    import { NETWORK_INFO_BY_ID } from '../../../../../constants/networks';
    import ActivationTasksMixin from '../../mixins/ActivationTasksMixin';
    import ActivationTaskIcon from '../../partials/tasks/ActivationTaskIcon.vue';

    export default {
        name: 'TasksList',
        props: {
            tasks: {
                type: Array,
                required: true
            },
            briefAccepted: {
                type: Boolean
            }
        },
        mixins: [ActivationTasksMixin],
        components: {
            ActivationTaskIcon
        },
        methods: {
            slug(networkId) {
                return NETWORK_INFO_BY_ID[networkId].slug;
            },
            quantityString(task) {
                if (this.briefAccepted) {
                    return task.quantity > 0 ? ` (${task.quantity})` : '';
                }
                const quantity = task.quantity !== 0 ? task.quantity : '∞';
                return ` (${task.complete_quantity}/${quantity})`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .task {
        display: flex;
        align-items: center;

        > span:first-child {
            margin-right: $g-spacing-2;
        }
    }
</style>
